import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'newLineToBr',
    standalone: false,
})
export class NewLineToBrPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return value;
        return value.replace(/\n/g, '<br>');
    }
}
